import { DatePicker } from "@/components/ui/date-picker";
import { isoBusinessDay } from "@/hooks/useReports";

// Business days, cut at the business-day start like every other report.
const PRESETS = [
  ["today", "Today", 0, 0],
  ["yesterday", "Yesterday", 1, 1],
  ["7", "7 days", 6, 0],
  ["30", "30 days", 29, 0],
];

export const presetRange = (preset, dayStart) => {
  const chosen = PRESETS.find(([key]) => key === preset) || PRESETS[0];
  return { fromDate: isoBusinessDay(chosen[2], dayStart), toDate: isoBusinessDay(chosen[3], dayStart) };
};

/** Preset buttons plus Custom; `value` is `{preset, fromDate, toDate}`. */
export default function CustomReportRange({ value, onChange, dayStart, testId = "custom-report-range" }) {
  const pick = preset =>
    onChange(preset === "custom" ? { ...value, preset } : { preset, ...presetRange(preset, dayStart) });
  return (
    <div className="flex flex-wrap items-center gap-snug" data-testid={testId}>
      <div className="flex bg-muted/50 p-hair rounded-lg border" role="group">
        {[...PRESETS.map(([key, label]) => [key, label]), ["custom", "Custom"]].map(([key, label]) => (
          <button
            key={key}
            type="button"
            aria-pressed={value.preset === key}
            className={`px-base py-hair text-meta font-medium rounded-md transition-colors ${value.preset === key ? "bg-background shadow-sm text-foreground" : "text-muted-foreground hover:text-foreground"}`}
            onClick={() => pick(key)}
            data-testid={`${testId}-${key}`}
          >
            {label}
          </button>
        ))}
      </div>
      {value.preset === "custom" && (
        <div className="flex items-center gap-tight">
          <DatePicker value={value.fromDate} max={value.toDate || undefined} onChange={fromDate => onChange({ ...value, fromDate })} ariaLabel="From" testId={`${testId}-from`} />
          <span className="text-meta text-muted-foreground font-semibold">to</span>
          <DatePicker value={value.toDate} min={value.fromDate || undefined} onChange={toDate => onChange({ ...value, toDate })} ariaLabel="To" testId={`${testId}-to`} />
        </div>
      )}
    </div>
  );
}
